import styled from 'styled-components'
import tw from 'twin.macro'

export const Articles = styled.div`
  ${tw`px-insetX`};
`

export const Columns = styled.div`
  ${tw`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8`};
`

export const Column = styled.div``

export const CategoryHeader = styled.div`
  ${tw`px-insetX py-5 lg:py-10 mb-8`};
  ${tw`flex justify-between items-end`};

  border-bottom: solid 1px var(--color-grey);
`
